import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from './img/case_img.png';
import _imports_1 from './img/damai.png';
import _imports_2 from './img/zhichi.png';
import _imports_3 from './img/haooubo.png';
import _imports_4 from './img/left.png';
import _imports_5 from './img/right.png';
const _hoisted_1 = {
  class: "service-case"
};
const _hoisted_2 = {
  class: "service-title"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "tab-box"
};
const _hoisted_5 = {
  class: "case-content"
};
const _hoisted_6 = {
  class: "case-info"
};
const _hoisted_7 = {
  class: "case-box"
};
const _hoisted_8 = {
  class: "case-txt"
};
const _hoisted_9 = {
  class: "btn-lists"
};
const _hoisted_10 = {
  class: "case-content"
};
const _hoisted_11 = {
  class: "case-info"
};
const _hoisted_12 = {
  class: "case-box"
};
const _hoisted_13 = {
  class: "case-txt"
};
const _hoisted_14 = {
  class: "btn-lists"
};
const _hoisted_15 = {
  class: "case-content"
};
const _hoisted_16 = {
  class: "case-info"
};
const _hoisted_17 = {
  class: "case-box"
};
const _hoisted_18 = {
  class: "case-txt"
};
const _hoisted_19 = {
  class: "btn-lists"
};
const _hoisted_20 = {
  class: "expert-box"
};
const _hoisted_21 = {
  class: "expert-title"
};
const _hoisted_22 = {
  class: "title"
};
const _hoisted_23 = {
  class: "sub-title"
};
const _hoisted_24 = {
  class: "swiper-box swiper-con1"
};
const _hoisted_25 = {
  class: "card-header"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "expert-name"
};
const _hoisted_28 = {
  class: "expert-school"
};
const _hoisted_29 = {
  class: "school"
};
const _hoisted_30 = {
  class: "speciality"
};
const _hoisted_31 = {
  class: "des-info"
};
const _hoisted_32 = {
  key: 0,
  class: "red"
};
const _hoisted_33 = {
  class: "school-txt"
};
const _hoisted_34 = {
  class: "honors-bg"
};
const _hoisted_35 = {
  class: "honors-box"
};
const _hoisted_36 = {
  class: "honors-title"
};
const _hoisted_37 = {
  class: "title"
};
const _hoisted_38 = {
  class: "swiper-box swiper-con2"
};
const _hoisted_39 = ["src"];
const _hoisted_40 = {
  class: "certificate-txt"
};
const _hoisted_41 = {
  class: "bottom-banner"
};
const _hoisted_42 = {
  class: "banner-con"
};
const _hoisted_43 = {
  class: "title"
};
import qs from 'qs';
import { Navigation } from 'swiper';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'partBottom',
  setup(__props) {
    const router = useRouter();
    const advisoryServiceRef = ref(null);
    const goAdvisory = () => {
      advisoryServiceRef['value'].show();
    };
    const partnerImgs = ref([
    // require('./img/partners1.png'),
    require('./img/partners2.png'), require('./img/partners3.png'), require('./img/partners4.png'), require('./img/partners5.png'), require('./img/partners6.png'), require('./img/partners7.png'), require('./img/partners8.png'), require('./img/partners9.png'), require('./img/partners10.png'), require('./img/partners11.png'), require('./img/partners12.png'), require('./img/partners13.png')]);
    const currentItem = ref({
      thumbnail: require('./img/expert1.png'),
      school: 'home.text137',
      name: 'Lorie 骆珊',
      speciality: 'home.text138',
      subDesc: 'home.text139',
      desc: 'home.text140'
    });
    const expertImgs = [{
      thumbnail: require('./img/expertWoman.png'),
      school: 'home.text137',
      name: 'Lorie 骆珊',
      speciality: 'home.text138',
      subDesc: 'home.text139',
      desc: 'home.text140'
    }, {
      thumbnail: require('./img/expertMan.png'),
      school: 'home.text141',
      name: '董维淳',
      speciality: 'home.text142',
      subDesc: 'home.text143',
      desc: 'home.text144'
    }, {
      thumbnail: require('./img/expertMan.png'),
      school: 'home.text145',
      name: '田中光启',
      speciality: 'home.text146',
      subDesc: 'home.text147',
      desc: 'home.text148'
    }, {
      thumbnail: require('./img/expertWoman.png'),
      school: 'home.text149',
      name: 'Yule 杨乐萍',
      speciality: 'home.text150',
      desc: 'home.text151'
    }, {
      thumbnail: require('./img/expertMan.png'),
      school: 'home.text152',
      name: 'Tyler 泰乐',
      speciality: 'home.text153',
      subDesc: 'home.text154',
      desc: 'home.text155'
    }, {
      thumbnail: require('./img/expertMan.png'),
      school: 'home.text156',
      name: 'Alva Ahmed',
      speciality: 'home.text157',
      subDesc: 'home.text158',
      desc: 'home.text159'
    }, {
      thumbnail: require('./img/expertWoman.png'),
      school: 'home.text160',
      name: '陈颖波',
      speciality: 'home.text161',
      subDesc: 'home.text162',
      desc: 'home.text163'
    }, {
      thumbnail: require('./img/expertWoman.png'),
      school: 'home.text164',
      name: '吴依旋',
      speciality: 'home.text165',
      subDesc: 'home.text166',
      desc: 'home.text167'
    }
    // {
    //   thumbnail: require('./img/expert9.png'),
    //   school: '中国医学科学院',
    //   name: '董维淳',
    //   speciality: '英语',
    //   subDesc: '四川大学华西医学院',
    //   desc: '毕业，现于复旦大学上海医学院任教，主要研究方向为医药生物技术，熟悉药品生产检验流程和医药信息，在《柳叶刀》和国外期刊发表多篇医学英语文章，翻译过临床试验文件、药品说明、诊断研究报告等。'
    // }
    ];
    const certificateImgs = [{
      img: require('./img/certificate1.png'),
      title: 'home.text168'
    }, {
      img: require('./img/certificate2.png'),
      title: 'home.text169'
    }, {
      img: require('./img/certificate3.png'),
      title: 'home.text170'
    }, {
      img: require('./img/certificate4.png'),
      title: 'home.text171'
    }, {
      img: require('./img/certificate5.png'),
      title: 'home.text172'
    }, {
      img: require('./img/certificate6.png'),
      title: 'home.text173'
    }, {
      img: require('./img/certificate7.png'),
      title: 'home.text174'
    }, {
      img: require('./img/certificate8.png'),
      title: 'home.text175'
    }, {
      img: require('./img/certificate9.png'),
      title: 'home.text176'
    }, {
      img: require('./img/certificate10.png'),
      title: 'home.text177'
    }];
    const state = reactive({
      activeIndex: 0,
      activeCertificateIndex: 0
    });
    const modules = [Navigation];
    // 成功案例
    const toCasePage = path => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      router.push(`/successCase/${path}`);
    };
    const onSlideChange = swiper => {
      state.activeIndex = swiper.realIndex;
      currentItem['value'] = expertImgs[state.activeIndex];
    };
    const handleClickImg = index => {
      state.activeIndex = index;
      currentItem['value'] = expertImgs[index];
    };
    // 去下单
    const toOrder = params => {
      if (params) {
        params = qs.stringify(params);
        window.location.href = `/client/order?${params}`;
      } else {
        window.location.href = '/client/order';
      }
    };
    const tabActive = ref('first');
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      const _component_AdvisoryService = _resolveComponent("AdvisoryService");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('home.text102')), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tabs, {
        modelValue: tabActive.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tabActive.value = $event),
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: '大麦',
          name: "first"
        }), _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('home.text104'),
          name: "second"
        }, null, 8, ["label"]), _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('home.text105'),
          name: "third"
        }, null, 8, ["label"])]),
        _: 1
      }, 8, ["modelValue"])])]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "case-img"
      }, [_createElementVNode("img", {
        src: _imports_0
      })], -1)), _createElementVNode("div", _hoisted_7, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "case-logo1",
        src: _imports_1
      }, null, -1)), _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('home.text106')), 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text107')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text108')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text109')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text110')), 1)]),
        _: 1
      })]), _createVNode(_component_el_button, {
        class: "hollow-btn",
        onClick: _cache[1] || (_cache[1] = $event => toCasePage('barleyWeb'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text111')), 1)]),
        _: 1
      })])])], 512), [[_vShow, tabActive.value == 'first']]), _withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "case-img"
      }, [_createElementVNode("img", {
        src: _imports_0
      })], -1)), _createElementVNode("div", _hoisted_12, [_cache[6] || (_cache[6] = _createElementVNode("img", {
        class: "case-logo2",
        src: _imports_2
      }, null, -1)), _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('home.text112')), 1), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text113')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text114')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text115')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text116')), 1)]),
        _: 1
      })]), _createVNode(_component_el_button, {
        class: "hollow-btn",
        onClick: _cache[2] || (_cache[2] = $event => toCasePage('wisdom'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text111')), 1)]),
        _: 1
      })])])], 512), [[_vShow, tabActive.value == 'second']]), _withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "case-img"
      }, [_createElementVNode("img", {
        src: _imports_0
      })], -1)), _createElementVNode("div", _hoisted_17, [_cache[8] || (_cache[8] = _createElementVNode("img", {
        class: "case-logo3",
        src: _imports_3
      }, null, -1)), _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('home.text117')), 1), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text118')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text119')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text120')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text121')), 1)]),
        _: 1
      })]), _createVNode(_component_el_button, {
        class: "hollow-btn",
        onClick: _cache[3] || (_cache[3] = $event => toCasePage('haooubo'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.text111')), 1)]),
        _: 1
      })])])], 512), [[_vShow, tabActive.value == 'third']])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('home.text122')), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('home.text123')), 1)]), _createElementVNode("div", _hoisted_24, [_createVNode(_unref(Swiper), {
        class: "swiper-lists",
        loop: true,
        "loop-additional-slides": 2,
        "space-between": 15,
        "slide-to-clicked-slide": true,
        width: 340,
        modules: modules,
        keyboard: true,
        mousewheel: true,
        navigation: {
          nextEl: '.swiper-con1 .swiper-button-next',
          prevEl: '.swiper-con1 .swiper-button-prev'
        },
        onSlideChange: onSlideChange
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(expertImgs, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            key: index,
            class: _normalizeClass(["img-box", {
              active: state.activeIndex == index
            }]),
            onClick: $event => handleClickImg(index)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
              src: item.thumbnail
            }, null, 8, _hoisted_26), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_27, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t(item['school'])), 1), _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t(item['speciality'])), 1)])])]), _createElementVNode("div", _hoisted_31, [item['subDesc'] ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t(item['subDesc'])), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t(item['desc'])), 1)])]),
            _: 2
          }, 1032, ["class", "onClick"]);
        }), 64))]),
        _: 1
      }), _cache[10] || (_cache[10] = _createElementVNode("img", {
        src: _imports_4,
        class: "swiper-button-prev"
      }, null, -1)), _cache[11] || (_cache[11] = _createElementVNode("img", {
        src: _imports_5,
        class: "swiper-button-next"
      }, null, -1))])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('home.text124')), 1)]), _createElementVNode("div", _hoisted_38, [_createVNode(_unref(Swiper), {
        class: "swiper-lists",
        loop: true,
        "loop-additional-slides": 5,
        "space-between": 40,
        "slide-to-clicked-slide": true,
        width: 180,
        modules: modules,
        keyboard: true,
        mousewheel: true,
        navigation: {
          nextEl: '.swiper-con2 .swiper-button-next',
          prevEl: '.swiper-con2 .swiper-button-prev'
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(certificateImgs, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            key: index,
            class: _normalizeClass(["certificate-item", {
              active: state.activeCertificateIndex == index
            }])
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "certificate-img",
              src: item.img
            }, null, 8, _hoisted_39), _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t(item.title)), 1)]),
            _: 2
          }, 1032, ["class"]);
        }), 64))]),
        _: 1
      }), _cache[12] || (_cache[12] = _createElementVNode("img", {
        src: _imports_4,
        class: "swiper-button-prev"
      }, null, -1)), _cache[13] || (_cache[13] = _createElementVNode("img", {
        src: _imports_5,
        class: "swiper-button-next"
      }, null, -1))])])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.$t('home.text125')), 1), _createElementVNode("span", {
        class: "consult-btn",
        onClick: goAdvisory
      }, _toDisplayString(_ctx.$t('home.text126')), 1)])]), _createVNode(_component_AdvisoryService, {
        ref_key: "advisoryServiceRef",
        ref: advisoryServiceRef
      }, null, 512)], 64);
    };
  }
});